// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#message-detail-subheader-left {
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}
#message-detail-subheader-left div:first-child {
  font-size: x-large;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  margin-right: 12px;
}
#message-detail-subheader-left div:first-child ion-icon {
  width: 36px;
  height: 36px;
  color: var(--ion-color-secondary, blue);
}
#message-detail-subheader-left div:last-child {
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  margin: auto;
}

#message-detail-subheader-right {
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: 16px;
}

ion-card.boxx-card {
  margin-top: 16px;
  padding: 16px;
}

.top-row {
  display: flex;
  justify-content: space-between;
}
.top-row .user-info-wrapper {
  display: flex;
  align-items: center;
}
.top-row .user-info-wrapper .avatar-wrapper {
  margin-right: 16px;
}
.top-row .user-info-wrapper .avatar-wrapper ion-avatar {
  width: 36px;
  height: 36px;
}
.top-row .user-info-wrapper .sender-name {
  font-size: 14px;
  font-weight: 600;
}
.top-row .conversation-date {
  font-size: 12px;
  font-weight: 500;
  color: var(--ion-color-medium);
}

.review-body,
.review-reply {
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-primary);
}

.review-reply {
  margin-bottom: 0px;
}

.review-rating-wrapper {
  margin-bottom: -2px;
}
.review-rating-wrapper .review-stars-icon {
  color: var(--ion-color-medium);
  width: 16px;
  height: 16px;
}
.review-rating-wrapper .review-stars-icon.active {
  color: #f0c300;
}

@media screen and (min-width: 960px) {
  ion-card.boxx-card {
    max-width: 75%;
    min-width: 310px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/messages-core/lib/components/review-item-open/review-item-open.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,uCAAA;AACN;AAGE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAGI;EACE,kBAAA;AADN;AAEM;EACE,WAAA;EACA,YAAA;AAAR;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAIE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAFJ;;AAMA;;EAEE,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;AAGE;EACE,8BAAA;EACA,WAAA;EACA,YAAA;AADJ;AAGI;EACE,cAAA;AADN;;AAMA;EACE;IACE,cAAA;IACA,gBAAA;EAHF;AACF","sourcesContent":["#message-detail-subheader-left {\n  display: flex;\n  margin-top: 8px;\n  margin-bottom: 8px;\n\n  div:first-child {\n    font-size: x-large;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    margin-right: 12px;\n\n    ion-icon {\n      width: 36px;\n      height: 36px;\n      color: var(--ion-color-secondary, blue);\n    }\n  }\n\n  div:last-child {\n    line-height: 1.2;\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n  }\n}\n\n#message-detail-subheader-right {\n  line-height: 1.2;\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n  margin-right: 16px;\n}\n\nion-card.boxx-card {\n  margin-top: 16px;\n  padding: 16px;\n}\n\n.top-row {\n  display: flex;\n  justify-content: space-between;\n\n  .user-info-wrapper {\n    display: flex;\n    align-items: center;\n    .avatar-wrapper {\n      margin-right: 16px;\n      ion-avatar {\n        width: 36px;\n        height: 36px;\n      }\n    }\n    .sender-name {\n      font-size: 14px;\n      font-weight: 600;\n    }\n  }\n  .conversation-date {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n  }\n}\n\n.review-body,\n.review-reply {\n  margin-top: 8px;\n  margin-bottom: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ion-color-primary);\n}\n.review-reply {\n  margin-bottom: 0px;\n}\n\n.review-rating-wrapper {\n  margin-bottom: -2px;\n  .review-stars-icon {\n    color: var(--ion-color-medium);\n    width: 16px;\n    height: 16px;\n\n    &.active {\n      color: #f0c300;\n    }\n  }\n}\n\n@media screen and (min-width: 960px) {\n  ion-card.boxx-card {\n    max-width: 75%;\n    min-width: 310px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
